package views.representante

import androidx.compose.runtime.Composable
import kotlinx.browser.document
import kotlinx.dom.clear
import lbTitulo
import org.jetbrains.compose.web.dom.Br
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.renderComposable
import org.w3c.dom.HTMLDivElement
import utils.ff
import utils.ff.Companion.gsNavePage
import utils.ffInverte

class rep001 {

    fun show() {

        lbTitulo!!.innerText = "001 - Representante"

        val htmlDiv1 = document.getElementById("htmlDiv1") as HTMLDivElement
        htmlDiv1.clear()

        renderComposable(rootElementId = "htmlDiv1") {
            body()
            //if (lemp5 != null && lemp5!!.count() > 0)
            //body1(lemp5!!)
        }
    }

    @Composable
    fun body() {
        Div(attrs = { classes("dlg-pad-top-5") }) {

            Div(attrs = { classes("form-group") }) {
                Button(attrs = {
                    classes("btn", "dlg-mobbt100"); onClick { _ ->
                    clickCortesFaturamento()
                }
                }
                ) {
                    Text("Cortes no faturamento")
                }
            }
            //Br()
            Div(attrs = { classes("form-group") }) {
                Button(attrs = {
                    classes("btn", "dlg-mobbt100"); onClick { _ ->
                    clickNotasFaturadas()
                }
                }
                ) {
                    Text("Notas faturadas")
                }
            }
            //Br()
            Div(attrs = { classes("form-group") }) {
                Button(attrs = {
                    classes("btn", "dlg-mobbt100"); onClick { _ ->
                    clickOportunidadesVenda()
                }
                }
                ) {
                    Text("Oportunidades de venda")
                }
            }

        }

    }

    //******************************************************************************* INICIO DOS EVENTOS
    fun clickCortesFaturamento() {
        ff.println0("clickCortesFaturamento")
        principalREP().ffNavePage("rep003")
    }

    fun clickNotasFaturadas() {
        ff.println0("clickNotasFaturadas")
        principalREP().ffNavePage("rep004")
    }

    fun clickOportunidadesVenda() {
        ff.println0("clickOportunidadesVenda")
        principalREP().ffNavePage("rep005")
    }

}